export default __webpack_public_path__ + "static/w5-9e751cb18af5b169871f439c1cc261c1.webp";